import { render } from "./ReactivSearch.vue?vue&type=template&id=7c70f4ce&scoped=true"
import script from "./ReactivSearch.vue?vue&type=script&lang=js"
export * from "./ReactivSearch.vue?vue&type=script&lang=js"

import "./ReactivSearch.vue?vue&type=style&index=0&id=7c70f4ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c70f4ce"]])

export default __exports__